export const plans = [
  {
    "year": "2025",
    "countyId": "086",
    "county": "Miami-Dade",
    "id": "27",
    "name": "Solis Balanced Plan"
  },
  {
    "year": "2026",
    "countyId": "086",
    "county": "Miami-Dade",
    "id": "27",
    "name": "Solis Balanced Plan"
  },
  {
    "year": "2026",
    "countyId": "105",
    "county": "Polk",
    "id": "23",
    "name": "Solis Guardian Plan"
  },
  {
    "year": "2025",
    "countyId": "086",
    "county": "Miami-Dade",
    "id": "2",
    "name": "Solis Guardian Plan"
  },
  {
    "year": "2026",
    "countyId": "011",
    "county": "Broward",
    "id": "12",
    "name": "Solis Guardian Plan"
  },
  {
    "year": "2026",
    "countyId": "057,103,101",
    "county": "Hillsborough, Pasco, Pinellas",
    "id": "10",
    "name": "Solis Guardian Plan"
  },
  {
    "year": "2025",
    "countyId": "057,103,101",
    "county": "Hillsborough, Pinellas, Pasco",
    "id": "10",
    "name": "Solis Guardian Plan"
  },
  {
    "year": "2025",
    "countyId": "099",
    "county": "Palm Beach",
    "id": "13",
    "name": "Solis Guardian Plan"
  },
  {
    "year": "2025",
    "countyId": "011",
    "county": "Broward",
    "id": "12",
    "name": "Solis Guardian Plan"
  },
  {
    "year": "2026",
    "countyId": "099",
    "county": "Palm Beach",
    "id": "13",
    "name": "Solis Guardian Plan"
  },
  {
    "year": "2025",
    "countyId": "105",
    "county": "Polk",
    "id": "23",
    "name": "Solis Guardian Plan"
  },
  {
    "year": "2025",
    "countyId": "095,097,117",
    "county": "Orange, Osceola, Seminole",
    "id": "25",
    "name": "Solis Guardian Plan"
  },
  {
    "year": "2026",
    "countyId": "095,097,117",
    "county": "Orange, Osceola, Seminole",
    "id": "25",
    "name": "Solis Guardian Plan"
  },
  {
    "year": "2026",
    "countyId": "086",
    "county": "Miami-Dade",
    "id": "2",
    "name": "Solis Guardian Plan"
  },
  {
    "year": "2025",
    "countyId": "011",
    "county": "Broward",
    "id": "7",
    "name": "Solis Healthy Living Plan"
  },
  {
    "year": "2026",
    "countyId": "099",
    "county": "Palm Beach",
    "id": "8",
    "name": "Solis Healthy Living Plan"
  },
  {
    "year": "2025",
    "countyId": "099",
    "county": "Palm Beach",
    "id": "8",
    "name": "Solis Healthy Living Plan"
  },
  {
    "year": "2026",
    "countyId": "011",
    "county": "Broward",
    "id": "7",
    "name": "Solis Healthy Living Plan"
  },
  {
    "year": "2026",
    "countyId": "057,103,101",
    "county": "Hillsborough, Pinellas, Pasco",
    "id": "9",
    "name": "Solis Healthy Living Plan"
  },
  {
    "year": "2025",
    "countyId": "057,103,101",
    "county": "Hillsborough, Pinellas, Pasco",
    "id": "9",
    "name": "Solis Healthy Living Plan"
  },
  {
    "year": "2026",
    "countyId": "105",
    "county": "Polk",
    "id": "20",
    "name": "Solis Healthy Living Plan"
  },
  {
    "year": "2025",
    "countyId": "105",
    "county": "Polk",
    "id": "20",
    "name": "Solis Healthy Living Plan"
  },
  {
    "year": "2026",
    "countyId": "086",
    "county": "Miami-Dade",
    "id": "22",
    "name": "Solis Healthy Living Plan"
  },
  {
    "year": "2025",
    "countyId": "095,097,117",
    "county": "Orange, Osceola, Seminole",
    "id": "24",
    "name": "Solis Healthy Living Plan"
  },
  {
    "year": "2025",
    "countyId": "086",
    "county": "Miami-Dade",
    "id": "22",
    "name": "Solis Healthy Living Plan"
  },
  {
    "year": "2026",
    "countyId": "095,097,117",
    "county": "Orange, Osceola, Seminole",
    "id": "24",
    "name": "Solis Healthy Living Plan"
  },
  {
    "year": "2026",
    "countyId": "086",
    "county": "Miami-Dade",
    "id": "28",
    "name": "Solis Wellness Giveback Plan"
  },
  {
    "year": "2026",
    "countyId": "011",
    "county": "Broward",
    "id": "30",
    "name": "Solis Wellness Giveback Plan"
  },
  {
    "year": "2026",
    "countyId": "057,103,101",
    "county": "Hillsborough, Pasco, Pinellas",
    "id": "31",
    "name": "Solis Wellness Giveback Plan"
  },
  {
    "year": "2026",
    "countyId": "105",
    "county": "Polk",
    "id": "32",
    "name": "Solis Wellness Giveback Plan"
  },
  {
    "year": "2026",
    "countyId": "095,097,117",
    "county": "Orange, Osceola, Seminole",
    "id": "33",
    "name": "Solis Wellness Giveback Plan"
  },
  {
    "year": "2026",
    "countyId": "099",
    "county": "Palm Beach",
    "id": "30",
    "name": "Solis Wellness Giveback Plan"
  },
  {
    "year": "2026",
    "countyId": "086",
    "county": "Miami-Dade",
    "id": "16",
    "name": "Solis Wellness Plan"
  },
  {
    "year": "2025",
    "countyId": "086",
    "county": "Miami-Dade",
    "id": "16",
    "name": "Solis Wellness Plan"
  },
  {
    "year": "2026",
    "countyId": "011",
    "county": "Broward",
    "id": "17",
    "name": "Solis Wellness Plan"
  },
  {
    "year": "2025",
    "countyId": "011",
    "county": "Broward",
    "id": "17",
    "name": "Solis Wellness Plan"
  },
  {
    "year": "2026",
    "countyId": "099",
    "county": "Palm Beach",
    "id": "18",
    "name": "Solis Wellness Plan"
  },
  {
    "year": "2025",
    "countyId": "099",
    "county": "Palm Beach",
    "id": "18",
    "name": "Solis Wellness Plan"
  },
  {
    "year": "2025",
    "countyId": "057,103,101",
    "county": "Hillsborough, Pinellas, Pasco",
    "id": "19",
    "name": "Solis Wellness Plan"
  },
  {
    "year": "2026",
    "countyId": "057,103,101",
    "county": "Hillsborough, Pinellas",
    "id": "19",
    "name": "Solis Wellness Plan"
  },
  {
    "year": "2026",
    "countyId": "105",
    "county": "Polk",
    "id": "21",
    "name": "Solis Wellness Plan"
  },
  {
    "year": "2025",
    "countyId": "105",
    "county": "Polk",
    "id": "21",
    "name": "Solis Wellness Plan"
  },
  {
    "year": "2025",
    "countyId": "095,097,117",
    "county": "Orange, Osceola, Seminole",
    "id": "26",
    "name": "Solis Wellness Plan"
  },
  {
    "year": "2026",
    "countyId": "095,097,117",
    "county": "Orange, Osceola, Seminole",
    "id": "26",
    "name": "Solis Wellness Plan"
  }
];